import { render, staticRenderFns } from "./RootProject.vue?vue&type=template&id=fb5ffe90"
import script from "./RootProject.vue?vue&type=script&lang=js"
export * from "./RootProject.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports